<template>
  <div
    :class="`workpackage ${workpackage_color}`"
    :style="`
      ${dimensions} 
      ${easter_egg?'border-radius: 50% / 60% 60% 40% 40% !important':''}
      ${$store.state.View.show_taktplan_shadows
        ?
          `box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);`
        :
          ''}
      `"
    ref="wp"
  >
    <slot name="workpackage" :workpackage="workpackage"/>
    <div class="workpacke-flex-ver">
      <div class="workpackage-flex-hor">
        <TIcon
          v-if="!hide_icon && getNewIcon(workpackage_icon)"
          :name="getNewIcon(workpackage_icon)"
          medium
          :color="textcolor ? textcolor : 'black'"
          class="svg-icon"
          :style="`
            ${zoom?`zoom: ${zoom};`:''}`"
        />
        <div
          class="workpackage-token font-weight-light ml-1"
          v-if="workpackage_token && ((!workpackage_count || workpackage_count === 1) && !easter_egg)"
          :style="`
            ${zoom?`font-size: calc(12px * ${zoom});`:''}
            ${textcolor?`color: ${textcolor};`:'color: black;'}
          `"
          >
          <span v-if="!hide_token">{{workpackage_token}}</span>
        </div>
      </div>
      <div
        class="wp-part font-weight-light"
        v-if="workpackage && workpackage.workpackage_part !== 1"
        :style="`color: ${workpackage.color.includes('darken')?'white':'black'}`"
      >
        {{workpackage.workpackage_part}}
      </div>
    </div>
  </div>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import {
  mapGetters,
  // mapActions
 } from 'vuex';
export default {
  name: 'workpackage',
  props: ['color', 'token', 'icon', 'workpackage_count', 'workpackage', 'zoom', 'easter_egg', 'textcolor', 'waggon_duration', 'hide_icon', 'hide_token', 'hide_color'],
  data: () => ({
  }),
  // updated(){
  //   console.log('workpackage updated');
  // },
  components: {
    TIcon,
  },
  computed: {
    ...mapGetters('WorkPackage', [
      'getNewIcon',
      ],
    ),
    workpackage_color() {

      if (this.hide_color) {
        return false;
      }

      if (this.color) {
        return this.color
      } else if (this.workpackage && !this.workpackage.color.includes('lighten') && !this.workpackage.color.includes('darken')){
        return `${this.workpackage.color} lighten-1`
      } else if (this.workpackage) {
        return `${this.workpackage.color}`
      } else {
        return false
      }
    },
    workpackage_icon() {
      if (this.icon) {
        return this.icon
      } else if (this.workpackage){
        return this.workpackage.icon
      } else {
        return false
      }
    },
    workpackage_token() {
      if (this.token) {
        return this.token
      } else if (this.workpackage){
        return this.workpackage.token
      } else {
        return false
      }
    },
    dimensions: function() {
      if (this.workpackage_count) {
        let column_count = 2
        let row_count = 1
        if (this.workpackage_count !== 2) {
          column_count = Math.ceil(this.workpackage_count/2)
          if (this.easter_egg) {
            column_count = column_count * 2
          }
        }
        if (this.workpackage_count > 2) {
          row_count = 2
        }
        if (this.zoom) {
        return `width: calc(var(--workpackage_width) * ${this.zoom}/ ${column_count});
                height: calc(var(--workpackage_height) * ${this.zoom} / ${row_count});
                margin: calc(2px * ${this.zoom} / ${row_count}) calc(2px * ${this.zoom} / ${column_count});
                border-radius: calc(3px * ${this.zoom}) !important;`
        } else {
        return `width: calc(var(--workpackage_width) * var(--taktplan_zoom) * ${this.waggon_duration?this.waggon_duration:1} / ${column_count} ${this.waggon_duration?`2px * var(--taktplan_zoom) * ${this.waggon_duration} / ${column_count}`:''});
                height: calc(var(--workpackage_height) * var(--taktplan_zoom) / ${row_count});
                margin: calc(2px * var(--taktplan_zoom) / ${row_count}) calc(2px * var(--taktplan_zoom) / ${column_count});`
        }
      } else if (this.zoom) {
        return `width: calc(var(--workpackage_width) * ${this.zoom});
                height: calc(var(--workpackage_height) * ${this.zoom});
                margin: calc(2px * ${this.zoom});
                border-radius: calc(3px * ${this.zoom}) !important;`
      } else {
        return ''
      }
    },
  },
  methods: {
  }
}
</script>
<style>
  .workpackage {
    position: relative;
    width: calc(var(--workpackage_width) * var(--taktplan_zoom));
    height: calc(var(--workpackage_height) * var(--taktplan_zoom));
    border-radius: calc(3px * var(--taktplan_zoom)) !important;
    margin: calc(2px * var(--taktplan_zoom));
    will-change: width, height;
    transition: none;

    /* v-card css */
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    transition-property: box-shadow,opacity;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
    flex-shrink: 0;
  }
  .workpackage-flex-hor {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .workpacke-flex-ver {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .workpackage-token {
    /* margin-left: auto;
    margin-right: auto; */
    color: black;
    font-size: calc(12px * var(--taktplan_zoom));
    user-select: none;
  }
  .svg-icon {
    zoom: var(--taktplan_zoom);
  }
  .wp-part {
    position: absolute !important;
    font-size: calc(8px * var(--taktplan_zoom));
    bottom: 0px;
    right: calc(20px * var(--taktplan_zoom));
  }
</style>
